export function normalize(string) {
  if (!string) return ''
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
}